import { createContext, useContext } from 'react';
import { SecurityProfile } from './api';

interface SecurityContextValue {
  profile?: SecurityProfile;
  refreshProfile: () => Promise<SecurityProfile | undefined>;
}
export const SecurityContext = createContext<SecurityContextValue>({
  refreshProfile: async () => undefined,
});
export const useLoginSecurity = () => useContext(SecurityContext);
